import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { PushNotificationService } from 'src/providers/pushnotification-service/pushnotification-service';
import { PushMessageButton } from './../../../data/mygolf.data';
import { CommonPullupMenuComponent } from './../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { ScorecardService } from './../../../providers/scorecard-service/scorecard-service';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { CurrentScorecardActions } from './../../../redux/scorecard/current-scorecard-actions';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
} from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { DeviceService } from 'src/providers/device-service/device-service';
import { DeviceInfo } from 'src/data/device-info';
import { AppInfo } from 'src/data/app-info';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
// import { ThrowStmt } from '@angular/compiler';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { FaqPage } from '../faq/faq.page';
import { ProfilePage } from '../profile/profile.page';
import { BookingHomePage } from '../booking/booking-home/booking-home.page';
import { DeleteRoomModalComponent } from '../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { Observable } from 'rxjs';
import {
  PlayerHomeInfo,
  PlainScoreCard,
  CompetitionInfo,
  PlayerInfo,
  CompetitionData,
  CompetitionMatch,
  CompetitionMatchParticipant,
} from 'src/data/mygolf.data';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { take } from 'rxjs/operators';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CompetitionFlowService } from 'src/app/services/competition-flow.service';
import * as globals from 'globals';

export interface FAQItem {
  title?: string;
  content?: string;
  expand?: boolean;
}

export interface GroupItem {
  groupTitle?: string;
  groupContent?: Array<FAQItem>;
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit, OnDestroy {
  deviceInfo: DeviceInfo = {
    deviceId: 'unknown',
    virtual: true,
  };
  appInfo: AppInfo = {};

  faqItems: Array<FAQItem> = new Array<FAQItem>();
  groupItems: Array<GroupItem> = new Array<GroupItem>();
  searchQuery: string;
  originalGroups: Array<any>;
  searchingMode: boolean = false;

  notfItems: any; //OSNotificationPayload;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  compsActiveToday: any = Array<any>();
  player: PlayerInfo;

  @Input() embedMode: boolean = false;

  constructor(
    private router: Router,
    private navCtrl: NavController,
    private deviceService: DeviceService,
    private platform: Platform,
    private flightService: ClubFlightService,
    private storage: MyGolfStorageService,
    private alertCtl: AlertController,
    private mdlCtrl: ModalController,
    private playerHomeService: PlayerHomeDataService,
    private playerHomeActions: PlayerHomeActions,
    private currentScorecardActions: CurrentScorecardActions,
    private competitionService: CompetitionService,
    private scorecardService: ScorecardService,
    private loadingCtl: LoadingController,
    private modalCtrl: ModalController,
    private pushNotfService: PushNotificationService,
    private customizerService: AppCustomizerService,
    private mg2uUtil: mygolfUtils,
    private competitionFlowService: CompetitionFlowService
  ) {
    this.platform = platform;

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.playerHomeInfo$.pipe(take(1)).subscribe((home: PlayerHomeInfo) => {
      if (home?.compsActiveToday?.length > 0) {
        this.compsActiveToday = home.compsActiveToday;
      }
      this.player = home.player;
    });

    this.pushNotfService.checkNotification().subscribe(
      (notf: any) => {
        this.clickNotf();
        // if (notf) this.clickNotf();
      },
      err => {},
      () => {
        this.pushNotfService.setHasNotification(false);
      }
    );

            this.customizerService.getSubsidiary().subscribe(subsidiary => {
              if (globals.appType === 'main') {
              } else {
                this.currentSubsidiary = subsidiary;
              }
            });
  }
  currentSubsidiary: string;

  ionViewDidEnter() {
    this.clickNotf();
  }
  ngOnInit() {
    this.deviceService.getDeviceInfo().then((deviceInfo: DeviceInfo) => {
      this.deviceInfo = deviceInfo;
    });
    this.deviceService.getAppInfo().then((appInfo: AppInfo) => {
      this.appInfo = appInfo;
    });
    this.onRefresh();
  }
  navigate() {
    // this.router.navigate(['/tabs/player-home']);
    this.customizerService.goToPlayerHome();
  }

  ionViewDidLoad() {
    // this.storage.getPreference('notifications')
    // .subscribe((a)=>{
    //     this.notfItems = a;
    // })
  }

  onRefresh(clear: boolean = false) {
    this.searchingMode = false;
    if (clear) this.searchQuery = '';

    this.flightService.getFAQ().subscribe((groupItems: Array<GroupItem>) => {
      if (groupItems && groupItems.length > 0) {
        this.groupItems = groupItems;
        this.originalGroups = this.groupItems;
        // this.originalGroups.push(this.groupItems)
      }
    });
  }
  ngOnDestroy() {}

  versionCode() {
    // return this.platform.versions()
  }

  isCordova() {
    return this.platform.is('capacitor');
  }
  toggleBookingClick(type: number) {}
  onHomeClick() {
    this.router.navigate(['tabs/player-home']);
    // this.navCtrl.popToRoot(); //this.nav.setRoot(PlayerHomePage);
  }

  expandPanel(item: FAQItem) {
    this.groupItems.forEach((gItems: GroupItem) => {
      gItems.groupContent.forEach((item: FAQItem) => {
        item.expand = false;
      });
    });
    item.expand = true;
    //   this.faqItems.forEach((item: FAQItem)=>{
    //       item.expand = false;
    //   })
    //   item.expand = true;
  }
  // async sendMessage() {
  //     let deviceInfo: DeviceInfo = await this.deviceService.getDeviceInfo();
  //
  //     this.stompService.sendMessage(deviceInfo,
  //         '/app//mygolf2u-ws/device/register');
  // }
  onSearchInput(searchbar) {
    // this.filteredBooking = [];
    if (this.searchQuery.length === 0) {
      this.searchingMode = false;
      this.onRefresh();
      return false;
    }
    this.searchingMode = true;
    let _filteredFaq: Array<FAQItem> = [];
    // let _filteredGroup = this.originalGroups.forEach((tGroup: GroupItem)=>{
    //     _filteredFaq = tGroup.groupContent.filter((tFAQ: FAQItem)=>{
    //         if(tFAQ.title.toLowerCase().includes(this.searchQuery.toLowerCase()))
    //             return 1
    //         else if(tFAQ.content.toLowerCase().includes(this.searchQuery.toLowerCase()))
    //             return 1
    //         else 0
    //     })
    // })

    let _filteredGroup = this.originalGroups.forEach((tGroup: GroupItem) => {
      tGroup.groupContent.forEach((faq: FAQItem) => {
        _filteredFaq.push(faq);
      });
    });
    _filteredFaq = _filteredFaq.filter((tFAQ: FAQItem) => {
      if (tFAQ.title.toLowerCase().includes(this.searchQuery.toLowerCase())) return 1;
      else if (tFAQ.content.toLowerCase().includes(this.searchQuery.toLowerCase())) return 1;
      else 0;
    });
    // if(_filteredGroup && _filteredGroup.length > 0)
    //     this.groupItems = _filteredGroup:null;

    this.faqItems = _filteredFaq;
    if (this.faqItems && this.faqItems.length > 0) this.faqItems[0].expand = true;
    // let _filteredBooking = this.bookingList.filter((tBooking: TeeTimeBooking) => {
    //     if (this.selectedSearchOpt.type === 'bookingRef') return tBooking.bookingReference.trim().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
    //     else if (this.selectedSearchOpt.type === 'mg2uId') {
    //         let _player;
    //         _player = tBooking.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
    //             return (String(player.player.id) === this.searchQuery.trim())
    //         })
    //         if (!_player || _player.length === 0) {
    //             return String(tBooking.bookedByPlayer.id) === this.searchQuery.trim()
    //         }
    //     }

    //     // return tBooking.booking.trim().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
    // }).sort((a, b) => {
    //     if (a.slotAssigned.startCourse.displayOrder < b.slotAssigned.startCourse.displayOrder)
    //         return -1;
    //     else if (a.slotAssigned.startCourse.displayOrder > b.slotAssigned.startCourse.displayOrder)
    //         return 1;
    //     else 0;
    // }).sort((a, b) => {
    //     if (a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime)
    //         return -1;
    //     else if (a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime)
    //         return 1;
    //     else 0;
    // });

    // if (_filteredBooking.length > 0 && _filteredBooking.length === 1) {
    //     this.navCtrl.push(BookingDetailsPage, {
    //         fromClub: true,
    //         teeSlotNew: false,
    //         bookingSlot: _filteredBooking[0]
    //     })
    // } else if (_filteredBooking.length > 1) {
    //     this.filteredBooking = _filteredBooking;
    // }
    // this._clearAndRefresh(null, null);
  }
  onSearchCancel(searchbar) {
    // this._clearAndRefresh(null, null);

    this.searchingMode = false;
    this.onRefresh();
  }

  testAddNotf() {
    let _msg: any = {
      id: '0:1758523773805082%98ae90d798ae90d7',
      data: {},
      title: 'Test notf capture',
      body: 'Pilot test messaging',
      tag: 'campaign_collapse_key_3186244098615317088',
    };
    if (!_msg?._dateTime) _msg._dateTime = null;
    _msg._dateTime = {
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm:ss'),
    };
    if (this.notfItems?.length === 0 || !this.notfItems) this.notfItems = [];
    this.notfItems.push(_msg);
  }
  clickNotf() {
    this.storage.getPreference('notifications').subscribe((a: Array<any>) => {
      if (a && a.length > 0) {
        this.notfItems = a.reverse();
        this.notfItems.forEach(n => {
          if (n?.notification && !n?.title) {
            n = {
              title: n?.notification?.title,
              body: n?.notification?.body,
            };
          }
          if (!n?.seeMore || n?.seeMore === undefined) n.seeMore = false;
          n.title = n?.title?.replace('myGolf2u :', '');
          if (!n?.messages || n?.messages === undefined) n.messages = null;
          n.messages = JSON.stringify(n);
        });
      }
      console.debug('get pref notf : ', a, JSON.stringify(a));
    });
    // if(!this.notfItems || (this.notfItems && this.notfItems.length === 0))
    // this.notfItems = [{
    //     title: '1 myGolf2u : Booking Confirmed',
    //     body: 'Booking Confirmed Booking Confirmed Booking Confirmed Booking Confirmed Booking Confirmed Booking Confirmed',
    //     additionalData: {
    //         type: 'bookingConfirmation'
    //     }
    // },{
    //     title: '2 Competition Started',
    //     body: 'Competition Round has started Competition Round has started Competition Round has started Competition Round has started',
    //     additionalData: {
    //         type: 'bookingFailure'
    //     }
    // },{
    //     title: '3 myGolf2u : Flight Changed',
    //     body: 'Body mesage body message Body mesage body message Body mesage body messageBody mesage body message',
    //     additionalData: {
    //         type: 'flightsChanged'
    //     }
    // },{
    //     title: '4 Competition Started',
    //     body: 'Competition Round has started Competition Round has started Competition Round has started Competition Round has started',
    //     additionalData: {
    //         type: 'competitionRoundStarted'
    //     }
    // },{
    //     title: 'myGolf2u : Friend Requested',
    //     body: 'Body mesage body message Body mesage body message Body mesage body messageBody mesage body message',
    //     additionalData: {
    //         type: 'friendsRequested'
    //     }
    // }]
    // this.notfItems.forEach((item)=>{
    //     item.title = item.title.replace('myGolf2u :','')
    // });
    // if(this.notfItems && this.notfItems.length > 0) this.notfItems = this.notfItems.reverse();
  }

  async onClearNotf(item) {
    let confirm = await this.alertCtl.create({
      header: 'Clear Notification',
      message: 'Do you want to clear this notification?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',

          handler: () => {
            confirm.dismiss();
            return false;
          },
        },
        {
          text: 'Clear',
          // cssClass: 'delete-item',
          role: 'delete',
          handler: () => {
            confirm.dismiss().then(() => {
              this.doClearNotf(item);
            });
            return false;
          },
        },
      ],
    });
    confirm.present();
  }

  doClearNotf(item) {
    let _item = item;
    this.notfItems = this.notfItems.filter(notf => {
      return notf !== _item;
    });
    this.storage.setPreference('notifications', this.notfItems);
  }

  async onClearAllNotf() {
    // let confirm = await this.alertCtl.create({
    //   header: "Clear All Notifications",
    //   message: "Do you want to clear all notifications?",
    //   buttons: [
    //     {
    //       text: 'No',
    //       role: "cancel",

    //       handler: () => {
    //         confirm.dismiss();
    //         return false;
    //       }
    //     },
    //     {
    //       text: 'Yes',
    //       // cssClass: 'delete-item',
    //       role: "delete",
    //       handler: () => {
    //         confirm.dismiss()
    //           .then(() => {
    //             this.doClearAllNotf();
    //           });
    //         return false;
    //       }
    //     }

    //   ]
    // });
    // confirm.present();
    let modal = await this.mdlCtrl.create({
      component: DeleteRoomModalComponent,
      showBackdrop: true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'notification',
        header: 'Clear All Notifications',
        msg: 'Do you want to clear all notifications?',
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      if (data) {
        if (data?.data === 'confirm') {
          this.doClearAllNotf();
        }
      }
    });
  }

  doClearAllNotf() {
    // let _item = item;
    this.notfItems = [];
    this.storage.setPreference('notifications', this.notfItems);
    this.pushNotfService.setHasNotification(false);
  }

  onNotificationsClick() {
    // this.navCtrl.push(NotificationsPage);
  }

  getNotfTypeIcon(item: any) {
    let _path = 'assets/img/';
    let _image;
    if (!item) return;
    if (item && !item.additionalData) return;
    if (item && !item.additionalData.type) return;
    let _type = item.additionalData.type;
    if (_type.toLowerCase().includes('bookin')) _image = 'home-icon-booking-registration.svg';
    else if (_type.toLowerCase().includes('competition')) _image = 'home-icon-tournament.svg';
    else if (_type.toLowerCase().includes('flights')) _image = 'club-icon-buggy.svg';
    else if (_type.toLowerCase().includes('friend')) _image = 'home-icon-friends.svg';
    else if (_type.toLowerCase().includes('scoring')) _image = 'book.png';
    else if (_type.toLowerCase().includes('profile')) _image = 'footer-icon-player.png';
    return _path + _image;
    // "bookingConfirmation"},
    // "bookingFailure"},
    // "competitionCancelled"},
    // "competitionInfoChange"},
    // "competitionRoundStarted"},
    // "flightsChanged","flightChanged":"01"},
    // "flightsChanged","flightChanged":"02"},
    // "flightsChanged","flightChanged":"2B"},
    // "flightsChanged","flightChanged":"Yes"},
    // "flightsGenerated"},
    // "friendRequest"},
    // "friendRequestAccepted"},
    // "scoringFinished"},
  }

  toggleMoreNotf(item) {
    item.seeMore = !item.seeMore;
  }

  onMyBookingsClick() {
    this.router.navigate(['booking-home']);
    // this.navCtrl.push(BookingHomePage);
  }

  onFAQClick() {
    // if(this.paymentClickedBoolean) return false;
    this.router.navigate(['tabs/faq']);
  }

  openProfile() {
    let navigationExtras: NavigationExtras = {
      state: {
        type: 'playerProfile',
      },
    };
    this.router.navigate(['tabs/profile'], navigationExtras);
  }

  async onClickCompsActive(competition) {
    // Use CompetitionFlowService to handle the flow:
    // 1. Check if matchplay → go to matchplay-scoring
    // 2. Check if compAllScores → go to scramble-scoring
    // 3. If all fails, open normal scoring (gameround-scoring)

    const _compId = competition.competitionId;
    let _continueMatchPlay: boolean = true;
    let _continueScramble: boolean = true;

    // Check if it's matchplay
    await this.competitionFlowService
      .checkWhetherCompMatch(competition, false, this.mg2uUtil)
      .then(async (cont: boolean) => {
        _continueMatchPlay = cont;
        console.debug('check whether comp match', cont, _continueMatchPlay);

        if (_continueMatchPlay) {
          // Not matchplay, check if it's compAllScores (scramble)
          await this.competitionFlowService
            .checkWhetherCompAllScores(competition, false, this.mg2uUtil)
            .then(async (contScramble: boolean) => {
              _continueScramble = contScramble;

              if (_continueScramble) {
                // Not matchplay and not scramble, open normal scoring
                await this.navigateToNormalScoring(_compId);
              }
            });
        }
      });
  }

  private async navigateToNormalScoring(compId: number) {
    let loader = this.loadingCtl.create({
      message: 'Getting scorecard. Please wait...',
      backdropDismiss: false,
      duration: 3000,
    });

    (await loader).present().then(() => {
      this.playerHomeActions.getCompetitionScoring(compId, this.player.playerId, loader);
      let getScorecard = setInterval(() => {
        this.scorecardService.getCurrentScorecard().subscribe((scorecard: PlainScoreCard) => {
          if (scorecard) {
            clearInterval(getScorecard);
            this.competitionService.getCompetitionInfo(compId).subscribe(
              (comp: CompetitionInfo) => {
                this.currentScorecardActions.setScoringPlayer(this.player.playerId);
                let navigationExtras: NavigationExtras = {
                  state: {
                    scorecard: scorecard,
                    competition: comp,
                    currentPlayer: this.player,
                  },
                };
                this.router.navigate(['gameround-scoring'], navigationExtras);
              },
              async error => {
                if (loader) (await loader).dismiss();
              },
              async () => {
                if (loader) (await loader).dismiss();
              }
            );
          }
        });
      }, 500);
    });
  }

  onClickDelete(item) {
    this.notfItems = this.notfItems.filter(notf => {
      return notf !== item;
    });
    this.storage.setPreference('notifications', this.notfItems);
  }

  async onClickNotification(item) {
    let _message = {
      title: item?.title,
      content: item?.body,
    };

    const modal = await this.modalCtrl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        message: _message,
        mode: 'infoDisplay',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {});
  }
}
